<svg width="72px" height="18px" viewBox="0 0 72 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <g id="Event-Web-Page" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <g id="Themes" transform="translate(-259.000000, -131.000000)" stroke="#979797">
      <g id="Safari" transform="translate(49.000000, 132.000000)">
        <g id="minimal-palette" transform="translate(211.000000, 0.000000)">
          <rect id="Rectangle" fill="#000000" x="0" y="0" width="20" height="20"></rect>
          <rect id="Rectangle" fill="#FAFAFA" x="25" y="0" width="20" height="20"></rect>
          <rect id="Rectangle" fill="#FF0B4F" x="50" y="0" width="20" height="20"></rect>
        </g>
      </g>
    </g>
  </g>
</svg>
